import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as GateSelectors from 'app/modules/gates/selectors'
import {
  compose,
  withProps,
  branch,
  renderNothing,
  withStateHandlers,
  withHandlers,
  withPropsOnChange,
} from 'recompose'
import { patchOperations } from 'utils/PatchHelper'

import { withRouter } from 'react-router'
import withOrgTeams from 'app/modules/teams/hoc/withOrgTeams'

import {
  teamMembers,
  onlineTeamMembers,
  offlineTeamMembers,
  updateAvailabilityForTeamPending,
  patchTeamPending,
} from 'app/modules/teams/selectors'
import { patchOrgTeam, deleteOrgTeam } from 'app/modules/teams/actions'
import { TEAM_NAME_EDIT_MODE } from 'app/modules/teams/constants'

import TeamSettings from './component'

const mapStateToProps = (state, { params }) => {
  return {
    teamMembers: teamMembers(state, { teamId: params.teamId }),
    onlineTeamMembers: onlineTeamMembers(params.teamId)(state),
    offlineTeamMembers: offlineTeamMembers(params.teamId)(state),
    settingsUpdatePending: updateAvailabilityForTeamPending(state),
    patchTeamPending: patchTeamPending(state),
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      patchOrgTeam,
      deleteOrgTeam,
    },
    dispatch
  ),
})

export default compose(
  withRouter,
  withOrgTeams,
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    () => ({
      teamName: undefined,
      teamNameEditMode: TEAM_NAME_EDIT_MODE.REVIEW,
      isEditModalVisible: false,
      isDeleteModalVisible: false,
      isDeleting: false,
    }),
    {
      setTeamNameEditMode: () => teamNameEditMode => ({ teamNameEditMode }),
      showEditModal: () => () => ({ isEditModalVisible: true }),
      hideEditModal: () => () => ({ isEditModalVisible: false }),
      showDeleteModal: () => () => ({ isDeleteModalVisible: true }),
      hideDeleteModal: () => () => ({ isDeleteModalVisible: false }),
      setIsDeleting: () => isDeleting => ({ isDeleting }),
      setTeamName: () => teamName => ({ teamName }),
    }
  ),
  withProps(({ teams, onlineTeamMembers, offlineTeamMembers, params }) => {
    const team = teams.find(team => team.id === params.teamId)
    return {
      team,
      activeCount: onlineTeamMembers.length,
      awayCount: offlineTeamMembers.length,
    }
  }),
  withPropsOnChange(['team'], ({ setTeamName, team }) => {
    !!team && setTeamName(team.name)
  }),
  withHandlers({
    handleEditTeamName: ({ setTeamNameEditMode }) => e => {
      setTeamNameEditMode(TEAM_NAME_EDIT_MODE.EDIT)
    },
    handleNameInputChange: ({ setTeamName }) => e => {
      setTeamName(e.target.value)
    },
    handleNameInputSave: ({ actions, teamName, team, setTeamNameEditMode }) => () => {
      actions.patchOrgTeam({
        teamId: team.id,
        properties: patchOperations({
          name: teamName,
        }),
      })
      setTimeout(() => {
        setTeamNameEditMode(TEAM_NAME_EDIT_MODE.REVIEW)
      }, 750)
    },
    handleNameInputCancel: ({ team, setTeamName, setTeamNameEditMode }) => () => {
      setTeamName(team.name)
      setTeamNameEditMode(TEAM_NAME_EDIT_MODE.REVIEW)
    },
    onConfirmDelete: ({ actions, team, router, setIsDeleting }) => () => {
      setIsDeleting(true)
      setTimeout(() => {
        actions.deleteOrgTeam({ teamId: team.id })
        router.push(`/settings/teams?delete=success&name=${team.name}`)
      }, 750)
    },
  }),
  branch(({ team, teamMembers }) => !(team && teamMembers), renderNothing)
)(TeamSettings)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Teams/Team/index.js